export default __webpack_public_path__ + "static/media/img1.000fa526.jpg";